import React from 'react';

import useSiteMetadata from '@hooks/useSiteMetadata';

import { StandardSection } from '@commons/standard-section/StandardSection';

import * as styles from './news-single-header.module.scss';

export default function NewsSingleHeader({ thumbnail }) {
  const { siteURL } = useSiteMetadata();
  return (
    <StandardSection
      className={styles.section}
      style={{
        background: `url(${siteURL}${thumbnail}) no-repeat center/cover`,
      }}
    >
    </StandardSection>
  );
}
